module.exports = require('./index').combine;
